// extracted by mini-css-extract-plugin
export var animation = "SessionInsights-module--animation--7d1c7";
export var blur = "SessionInsights-module--blur--14a7a";
export var clickMaps = "SessionInsights-module--click-maps--eb296";
export var data = "SessionInsights-module--data--2d88e";
export var fadeIn = "SessionInsights-module--fadeIn--c814d";
export var float = "SessionInsights-module--float--cda1f";
export var flow = "SessionInsights-module--flow--18065";
export var header = "SessionInsights-module--header--e2d8e";
export var heatmapGradient = "SessionInsights-module--heatmap-gradient--c35d3";
export var heatmapOverlay = "SessionInsights-module--heatmap-overlay--d462e";
export var particles = "SessionInsights-module--particles--d51a6";
export var particlesCanvas = "SessionInsights-module--particles-canvas--b7af9";
export var playback = "SessionInsights-module--playback--ee6b5";
export var playbackBar = "SessionInsights-module--playback-bar--1c370";
export var secured = "SessionInsights-module--secured--89f9e";
export var step = "SessionInsights-module--step--70c2c";